import { useTranslation } from "react-i18next";

export default function Vision() {
  const { t } = useTranslation();

  const items = [
    {
      key: "vision.left",
      title: t("vision.left.title"),
      text: t("vision.left.text"),
    },
    {
      key: "vision.right",
      title: t("vision.right.title"),
      text: t("vision.right.text"),
    },
  ];

  return (
    <section className="Vision fade" id="vision">
      <article className="title-content">
        <div className="title">
          <h2>{t("vision.title")}</h2>
          <p className="vision-subtitle">{t("vision.subtitle")}</p>
        </div>
        <div className="line" />
      </article>

      <ul className="vision-columns">
        {items.map(({ key, title, text }) => (
          <li key={key}>
            {/* Desktop: titres + textes visibles */}
            <div className="desktop-only">
              <h3>{title}</h3>
              <p>{text}</p>
            </div>

            {/* Mobile: h3 en accordéon */}
            <details className="mobile-only accordion">
              <summary>
                <h3>{title}</h3>
              </summary>
              <p>{text}</p>
            </details>
          </li>
        ))}
      </ul>
    </section>
  );
}
